export default "/images/3f0999fdcc437278fff35bcf915188e5.avif";